import { TmElement } from '@thiememeulenhoff/lit-sdk';
import { customElement, property, state } from 'lit/decorators.js';
import { html, nothing } from 'lit';
import { tagName } from '../../../helpers';

const tag = tagName('tab-panel');

@customElement(tag)
export class PanelComponent extends TmElement {
  @property({ type: String, reflect: true })
  readonly name!: string;

  @property({ type: Boolean, reflect: true, attribute: 'visible' })
  @state()
  visible = false;

  override render() {
    return this.visible
      ? html`<main part="panel"><slot></slot></main>`
      : nothing;
  }

  public setVisible(visible: boolean) {
    this.visible = visible;
  }

  override connectedCallback() {
    super.connectedCallback();
    this.setAttribute('role', 'tabpanel');
  }
}
